import React from 'react'
import AdminLoginForm from '../Components/AdminLogin/AdminLoginForm'

function AdminLogin() {
  return (
    <div>
        <AdminLoginForm />
    </div>
  )
}

export default AdminLogin 